module.exports = __webpack_public_path__ + "files/llorens.3fed8d459ea1d3eb1e72c5692d084bbf.pdf";